import profile from "./profile";
import dashboard from "./dashboard";
import products from "./products";
import orders from "./orders";
import mutualSettlements from "./mutual-settlements";
import priceLists from "./price-lists";
import market from "./market";
import leads from "./leads";
import reserved from "./reserved";
import serviceCases from "./service-cases";
import fleaMarket from "./flea-market";
import news from "./news";
import updates from "./updates";
import knowledgeBase from "./knowledge-base";
import settings from "./settings";
import wish from "./wish-list";
import bonusesProgram from "./bonuses-program";
import shipments from "./shipments";
import orderSuccess from "./order-success";

const MainLayout = () => import(/* webpackChunkName: "MainLayout" */ "@/layouts/_bit/admin-mono");

// TODO: change for "Products" when development will be finish
const redirectPage = process.env.VUE_APP_FEATURE_FLAG_LEGACY === "0" ? "Dashboard" : "FleaMarket";

const mainLayout = [
  {
    path: "/",
    name: "MainLayout",
    component: MainLayout,
    redirect: { name: redirectPage },
    children: [
      ...dashboard,
      ...products,
      ...orders,
      ...mutualSettlements,
      ...priceLists,
      ...market,
      ...leads,
      ...reserved,
      ...serviceCases,
      ...fleaMarket,
      ...news,
      ...updates,
      ...knowledgeBase,
      ...profile,
      ...settings,
      ...wish,
      ...bonusesProgram,
      ...shipments,
      ...orderSuccess,
    ],
  },
];

export default mainLayout;
